<template>
  <v-card>
    <v-card-title>
      Connected Guides
      <v-spacer />
      <v-btn
        outlined
        :to="`/guides?productId=${product.id}`"
      >
        Manage Guides
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        disable-pagination
        hide-default-footer
        hide-default-header
        :headers="[{ text: 'Name', value: 'name' }]"
        :items="guides"
      >
        <template #[`item.name`]="{ item }">
          {{ item.name }}
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                color="primary"
                class="ml-1"
                v-on="on"
              >
                info
              </v-icon>
            </template>
            <div class="tooltip-limit-width">
              {{ item.description }}
            </div>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductGuides',
  computed: {
    ...mapGetters({ guides: 'guides/list', product: 'products/product' })
  }
};
</script>
